printableSummary.classy.controller({
    name: 'PrintApplicationsController',
    inject: ['$scope', '$timeout', '$location', '$stateParams', '$anchorScroll', 
        'authServiceFactory', 'BinFactory', 'SchoolSubcategoriesModelService',
        'AccountModelService', 'BinService', 'BinSummaryService', 'ApplicationsSubNavbarService', 
        'PermissionModelService', 'SchoolModelService'],
    init: function()
    {
        this.$.stateParams = this.$stateParams;
        this.$.BinFactory = this.BinFactory;
        this.$.accounts = this.AccountModelService.get();
        this.$.categories = this.SchoolSubcategoriesModelService.get();
        this.$.BinSummaryService = this.BinSummaryService;
        this.$.SchoolModelService = this.SchoolModelService;
        this.$.BinService = this.BinService;
        this.BinService.updateFilter("taxFilter");
        this.BinService.updateFilter("gradeFilter");
        this.BinService.updateFilter("NRFilter");
        this.BinService.updateFilter("SubCatsFilter");
        this.BinService.updateFilter("accountsFilter");
        this.BinFactory.setAppFinYear(this.$stateParams.year, true);
        this.BinSummaryService.refresh(this.$stateParams.year);
        this.$.ApplicationsSubNavbarService = this.ApplicationsSubNavbarService;  
        this.$.faculty = this.PermissionModelService.get(this.authServiceFactory.getAuth().schoolID)[0].faculty;
        this.$.applications = this.BinFactory.get((this.BinService.appFilter).toLowerCase());
        this.$.bin = this.BinService.getBin();
        $(".index-loading-area").addClass("hidden");

        this.$.Accounts = {};
        for (var i = 0; i < this.AccountModelService.get().accounts.length; i++)
        {
            var account = this.AccountModelService.get().accounts[i];
            this.$.Accounts[account.recordID] = {}
            this.$.Accounts[account.recordID].Account = account.Account;
            this.$.Accounts[account.recordID].Budget = account.Budget;
        }


        $(".off-canvas-wrap").removeClass("off-canvas-wrap");
        // hotfixes for page-break-after in chrome
        $(".ng-scope").css("float", "none");
        $("body").css("float", "none");
        $("html").css("float", "none");
    },
    showBudget:function()
    {
        var ret = false;
        if (typeof this.BinService.filter['accountsFilter'] !== 'undefined')
        {
            for(var property in this.BinService.filter["accountsFilter"].values)
            {
                if (this.BinService.filter["accountsFilter"].values[property])
                    ret = property;
            }
        }
        return ret;
    },
    isInBudget: function(app, applicantIndex) {
        var applicantID = app.ApplicantIDs[applicantIndex];
        for (let budgetID in this.BinService.filter["accountsFilter"].values) {
            var noBudgets = true;
            if (this.BinService.filter["accountsFilter"].values[budgetID]==true) {
                noBudgets = false;
                for (let applBudgetID in app.budgetApplicants[applicantID]) {
                    if (app.budgetApplicants[applicantID][applBudgetID]==budgetID)
                        return true;
                }

            }
            if (noBudgets) return true;
        }
        return false;
    },
    isInGrade: function(app, applicantIndex) {
        var noFilter = true;
        for (var key in this.BinService.filter["gradeFilter"].values) {
            if (this.BinService.filter["gradeFilter"].values[key] == true)
                noFilter = false;
        }
        return noFilter || this.BinService.filter['gradeFilter'].values[app.Division_Code[applicantIndex]] == true;
    },
    calcAward: function(app)
    {
        var sum = 0;
        for (var i = 0; i < app.Applicants.length; i++) {
            if (this.isInGrade(app, i)==true) {
                sum += parseInt(app.ActAwards[i]);
            }
        }
        return sum;
    },
    differential: function()
    {
        if (!this.filterFilter(this.BinService.filter['accountsFilter']).length)
            return this.SchoolModelService.get()[0].Total_Award_Budget - this.BinSummaryService.calculateTotalAwarded();
        else if (this.$.Accounts[this.filterFilter(this.BinService.filter['accountsFilter'])[0]])
            return this.$.Accounts[this.filterFilter(this.BinService.filter['accountsFilter'])[0]].Budget - this.BinSummaryService.calculateTotalAwarded();
        else
            return 0;
    },
    filterFilter: function(values)
    {
        var result = [];
        for(let t in values.values)
        {
            if (values.values[t] == true) {
                result[result.length] = t;
            }
        }
        return result;
    }
});
